import { render } from "./dropdown-menu.vue?vue&type=template&id=5f3c003c&ts=true"
import script from "./dropdown-menu.vue?vue&type=script&lang=ts"
export * from "./dropdown-menu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__